import {
  Box,
  Avatar,
  AvatarBadge,
  VStack,
  Text,
  HStack,
} from "@chakra-ui/react";
import { Logo, Nav, IconComponent } from "@/components";
import { navigation } from "@/constants";
import { useAuthState, logout } from "@/store";
import { useLocation } from "@tanstack/react-router";
import { useMemo } from "react";

export const Sidebar = () => {
  const { user } = useAuthState();

  const location = useLocation();
  const navigationWithActive = useMemo(() => {
    return navigation.map((item) => {
      const pathPattern = item.url
        .replace(/\{[^}]+\}/g, '[^/]+')
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      
      const pathRegex = new RegExp(`^${pathPattern}$`);
      const isActive = pathRegex.test(location.pathname);

      return {
        ...item,
        isActive,
      };
    });
  }, [location.pathname]);

  const handleLogout = async () => {
    await logout();
    window.location.href = '/';
  };

  return (
    <VStack h="100%">
      <Box
        borderBottom="1px solid"
        borderColor="gray.100"
        p={3}
        px={8}
      >
        <Logo />
      </Box>
      <Box>
        <Nav
          direction="vertical"
          navigation={navigationWithActive}
        />
      </Box>
      <Box
        w="100%"
        mt="auto"
        borderTop="1px solid"
        borderColor="gray.100"
        p={3}
        px={8}
      >
        <HStack spacing={3}>
          <Avatar
            bg="primary.500"
            color="white"
            colorScheme="primary"
            size="md"
            name={user?.name}
          >
            <AvatarBadge boxSize="1.25em" bg="green.500" />
          </Avatar>
          <VStack gap="0" align="start" spacing={0}>
            <Text mb="0" fontWeight="medium">{user?.name}</Text>
            <HStack 
              cursor="pointer" 
              gap="1" 
              align="center" 
              spacing={0}
              onClick={handleLogout}
            >
              <Text 
                mt="0" fontSize="sm" color="gray.500"
                _hover={{
                  color: 'primary.500 !important',
                }}
              >
                Esci
              </Text>
              <Box 
                display="flex" color="gray.500"
                _hover={{
                  color: 'primary.500 !important',
                }}
              >
                <IconComponent type="arrow-right-from-bracket" />
              </Box>
            </HStack>
          </VStack>
        </HStack>
      </Box>
    </VStack>
  );
};